var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "row inner-content",
      class: [_vm.selection.machine.toLocaleLowerCase()]
    },
    [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.guages, function(item) {
            return _c(
              "div",
              { key: item.id, staticClass: "col-4" },
              [_c("guagechart", { attrs: { guageData: item } })],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-10" },
            [_c("areachart", { attrs: { chartData: _vm.costs } })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "offset-1 col-2" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-10" },
            [_c("barchart", { attrs: { chartData: _vm.throughput } })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-legend col-2" }, [
            _c("span", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.selection.machine.toLocaleUpperCase()))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("span", { staticClass: "date" }, [
              _vm._v(_vm._s(_vm.formatDate()))
            ]),
            _vm._v(" "),
            _c("br")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }